/**
 * The period in days for which we show data on our Dashboard chart
 * This is approximetly a range of 4 months.
 */
export default {
  DATA_PERIOD: 31,
  DEFAULT_DATE_RANGE: 31,
  DATE_FORMAT: 'YYYY-MM-DD',
  LABEL_FORMAT: 'ddd, D MMM YYYY'
};